import apiHelpers from './apiHelpers';

export default {
    getSetups() {
        return apiHelpers.httpRequest('setups', {}, 'get');
    },
    getSetup(app_id) {
        return apiHelpers.httpRequest(`setups/${app_id}`, {}, 'get');
    },
    addSetup(body) {
        return apiHelpers.httpRequest('setups', body, 'post');
    },
    deleteSetup(app_id) {
        return apiHelpers.httpRequest(`setups`, {app_id: app_id, skan: {}}, 'post');
    },

};
